// Телефон для показа. Хранится и уходит на сервер он одиннадцатью цифрами подряд —
// «79827266853», — и в таком виде его невозможно ни прочитать, ни продиктовать. Человек,
// звонящий охраннику на объект, читает номер с экрана вслух: без разбивки он сбивается на
// четвёртой цифре и набирает заново.
//
// Формат российский и один на весь продукт. Номер не той длины отдаётся как есть: подгонять
// чужой номер под нашу маску значит показать не тот телефон.

/** «79827266853» → «+7 982 726-68-53». Номер не той длины возвращается без изменений. */
export function formatPhone(значение: string | null | undefined): string | null {
  if (значение === null || значение === undefined) {
    return null;
  }
  const цифры = значение.replace(/\D/g, '');
  if (цифры.length !== 11 || (цифры[0] !== '7' && цифры[0] !== '8')) {
    return значение;
  }
  const код = цифры.slice(1, 4);
  const первая = цифры.slice(4, 7);
  const вторая = цифры.slice(7, 9);
  const третья = цифры.slice(9, 11);
  return `+7 ${код} ${первая}-${вторая}-${третья}`;
}
